<template>
  <div>
    <h2 class="border-none">Choose your interests and appear in more searches</h2>
    <div>
      <div class="spacer-b-2 lead-text">Adding interests will help get you more of the following</div>
      <div class="flex flex-row flex-wrap gray-500 w-2/3 justify-between">
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-user-circle"></i></div> Brand Ambassadorships</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-mobile"></i></div> Video Shout-outs</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-comments"></i></div> Social Media Campaigns</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-camera"></i></div> Meet & Greets</div>
      </div>
      <div class="spacer-t-5 lead-text">Select any areas that you are interested in</div>
      <div class="w-full" v-for="(categories, group) in interestCategories" :key="group">
        <h2>{{ group }}</h2>
        <div class="flex flex-wrap">
          <div v-for="(category, index) in categories"
               :key="category.id"
               class="category"
               :class="category.selected ? 'category--selected' : ''"
               @click="$emit('toggled', category.id, index, group, category.name)">
            <i class="fa" :class="category.selected ? 'fa-check' : 'fa-plus'"></i>
            {{ category.name }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <button class="add-button margin-y-4" @click="() => {showCustomCategories = !showCustomCategories}"><i class="fa" :class="showCustomCategories ? 'fa-minus' : 'fa-plus'"></i> Add other interests</button>
      <div v-if="showCustomCategories">
        <div class="margin-y-2 lead-text">Add any other interests you have that don't appear above</div>
        <search-picker
          :full-width="true"
          :with-icon="true"
          :with-popper="true"
          :get-data="getInterestCategories"
          @selected="(option) => { $emit('selected', option) }"
          :current="selectedCategories"
          placeholder="Search for an interest">
          <template v-slot:list-item-content="{ option }">
            <div
              v-if="option.group"
              class="search-picker__subtext">
              <span>{{ option.group }}</span>
            </div>
          </template>
        </search-picker>
        <div class="flex margin-t-2 flex-wrap">
          <div v-for="(category, index) in customCategories"
               :key="category.id"
               class="category category--selected">
            {{ category.name }}
            <i class="fa fa-times" @click="$emit('deleted', category.id, index, category.name)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagPicker from '../misc/TagPicker'
import SearchPicker from '../misc/SearchPicker'
import { http } from 'utils'
export default {
  components: { TagPicker, SearchPicker },
  props: {
    interestCategories: {
      required: true
    },
    customCategories: {
      required: true
    },
    selectedCategories: {
      required: true
    }
  },

  methods: {
    async getInterestCategories (params) {
      const response = await http.get('interest-categories', { params })
      return response.data.data
    }
  },

  mounted () {
    if (this.customCategories && this.customCategories.length) {
      this.showCustomCategories = true
    }
  },

  data () {
    return {
      showCustomCategories: false
    }
  }
}
</script>
